// API Configuration
const getApiBaseUrl = () => {

  if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {

    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    if (backendUrl) {
      return backendUrl;
    }
    
    // Fallback: use a subdomain or different port
    return 'https://app.zonasur.org.mx';
  }
  
  // Use localhost for development
  return 'http://localhost:3500';
};

export const API_BASE_URL = getApiBaseUrl(); 